import { gql } from '@apollo/client';

export * from './profile.query.generated';

export const PROFILE = gql`
  query profile {
    profile {
      email
      id
      name
      gravatarUrl
      phone
      role
    }
  }
`;
